import Moment from "react-moment";
import { Link, useParams } from "react-router-dom";
import { useAuth } from "../../context/Auth";
import { shareLink } from "../../utils/utils";
import { baseURL } from "../../api";
import { Modal } from "../../components";
import { useState } from "react";

const MembershipPaymentSuccess = () => {
  const { loginRedirectUrl, subscriptionData } = useAuth()
  const { membershipNumber, expiryDate, feedId } = useParams();

  const finalFeedId = subscriptionData?.feed_id || feedId;
  console.log("membershipNumber, expiryDate  =>", subscriptionData, { membershipNumber, expiryDate, finalFeedId });
  const [showModal, setModal] = useState(true)

  return (
    <>
      <div className="card shadow-xss w-100 d-block d-flex border-0 p-4 mb-3 ">
        <div className="card-body d-flex align-items-center p-0">
          <h2 className="fw-700 mb-0 mt-0 font-md text-grey-900 align-item-center d-flex">
            <i className="fa-sharp fa-solid fa-circle-check font-xxl mr-11 text-share" />
            Membership Payment Success
          </h2>
        </div>
      </div>

      <div className="card shadow-xss w-100 d-block d-flex border-0 p-4 mb-3 membership-payment-success">
        <div className="card-body align-items-center p-0">
          <p>
            Congratulations! Your upgrade to Premium Membership was successfully
            completed.
          </p>
          <p>
            Your Membership Number is {membershipNumber} and expires on{" "}
            <Moment format="DD MMM YYYY">{expiryDate}</Moment>
          </p>
          <div className="card-body mt-3 mb-3 rounded-3 overflow-hidden">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <img
                  src={"../images/premium-membership-success-new.png"}
                  alt="video"
                  className="w-100"
                />
              </div>
            </div>
            <div className="row mt-3 justify-content-center">
              <div className="col-lg-8 d-flex justify-content-center">
                <a
                  onClick={(e) => { e.preventDefault(); shareLink({ id: finalFeedId, premiumPost: true, image: 'https://icn-member.web.app/images/premium-membership-success-new.png' }); }}
                  href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(`${baseURL}/api/v1/feed/share/${finalFeedId}/2`)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-share-fb">
                  <div className="share-logos">
                    <div className="logo-wrapper">
                      <i className="fa-brands fa-instagram"></i>
                    </div>
                    <div className="logo-wrapper">
                      <i className="fa-brands fa-facebook-f"></i>
                    </div>
                  </div>
                  <span className="hidden-sm">Click and Share to Facebook &gt; Instagram</span>
                  <span className="show-sm">Click and Share to Facebook &gt; Instagram</span>
                </a>
                {/* <a
                  className="btn-share"
                  // href={`https://www.facebook.com/sharer/sharer.php?u=${loginRedirectUrl}/post/${feedId}`}
                  onClick={() => shareLink({ id: feedId })}
                  href={`https://www.facebook.com/sharer/sharer.php?u=${baseURL}/api/v1/feed/share/${feedId}/2`}
                  target="_blank"
                >
                  <div className="share-logos">
                    <div className="logo-wrapper">
                      <img
                        src="./images/icon-icompete-white.png"
                        alt="iCompete logo"
                      />
                    </div>
                    <div className="logo-wrapper">
                      <img
                        src="./images/icon-fb-white.png"
                        alt="Facebook logo"
                      />
                    </div>
                  </div>
                  <span className="hidden-sm">Share to Facebook from your iCompete Wall</span>
                  <span className="show-sm">Share to Facebook</span>
                </a> */}
              </div>
            </div>
          </div>

          <p>
            As a valued member of the iCompete Natural you will receive a
            Welcome email which includes:
          </p>
          <p>(HINT: Look in your junk or spam folder if not received)</p>
          <ul className="text-red" style={{ margin: "20px 50px" }}>
            <li style={{ listStyle: "disc inside" }}>
              Confirmation of the information you supplied us
            </li>
            <li style={{ listStyle: "disc inside" }}>
              Exclusive eBook The Competitor Encyclopedia
            </li>
            <li style={{ listStyle: "disc inside" }}>Tax Invoice</li>
          </ul>
          <p>
            To enter a contest go to{" "}
            <Link to="/enter-new-event">Enter New Event</Link>
          </p>
          <p>
            If you require any assistance please{" "}
            <Link to="/contact">contact us</Link>
          </p>
        </div>
      </div>
      <Modal
        show={showModal}
        onClick={() => {
          setModal(false);
        }}
        close={() => {
          setModal(false);
        }}
      >
        <div>
          <div className="row mt-3 mb-3 justify-content-center" style={{ maxWidth: 600, margin: '0 auto' }}>
            <div className="col-lg-12 d-flex justify-content-center">
              <a
                onClick={(e) => {
                  e.preventDefault();
                  setModal(false);
                  shareLink({ id: finalFeedId, premiumPost: true, image: 'https://icn-member.web.app/images/premium-membership-success-new.png' });
                }}
                href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(`${baseURL}/api/v1/feed/share/${finalFeedId}/2`)}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <div style={{ position: 'relative' }} >
                  <img src={"../images/premium-membership-success-new.png"} className="mb-3" />
                  {/* {loading ? <div style={{ position: 'absolute', bottom: 0, left: 0, height: '100%', width: '100%', flexDirection: 'column', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <img src="./images/preloader.svg" />
                  </div> : null} */}
                </div>
                <span
                  className="btn-share-fb">
                  <div className="share-logos">
                    <div className="logo-wrapper">
                      <i className="fa-brands fa-instagram"></i>
                    </div>
                    <div className="logo-wrapper">
                      <i className="fa-brands fa-facebook-f"></i>
                    </div>
                  </div>
                  <span className="hidden-sm bold" style={{ textShadow: '0 1px 3px rgba(0,0,0,0.5)' }}>Click and Share to Facebook &gt; Instagram</span>
                  <span className="show-sm">Click and Share to Facebook &gt; Instagram</span>
                </span>
              </a>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default MembershipPaymentSuccess;
